var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center px-3 pt-3 px-4"},[_c('div',{staticClass:"px-4",staticStyle:{"font-size":"1.1rem","font-style":"italic !important"}},[_vm._v("It's time to see who's really on your website")])])])
}]

export { render, staticRenderFns }